<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-05 16:16:35
 * @LastEditTime: 2019-09-02 18:48:30
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
        <div class="pageTitle">查看详情</div>
          <el-row style='margin-bottom:15px;'>
              <el-col :span='2'>
                  订单状态:
              </el-col>
              <el-col :span='10'>
                     <span v-if="form.status == 3">  待付款</span>
                                    <span v-if="form.status == 1">待收货</span>
                                    <span v-if="form.status == 2">发货中</span>
                                    <span v-if="form.status == 4"> 待审核</span>

                                    <span v-if="form.status == 5">审核不通过</span>
                                    <span v-if="form.status == 6"> 已完成</span>
                                    <span v-if="form.status == 7"> 已取消</span>
                                    <span v-if="form.status == 0">待发货</span>
              </el-col>
          </el-row >
            <el-row  style='margin-bottom:15px;'>
              <el-col :span='2'>
                  订单号:
              </el-col>
              <el-col :span='10'>
                <span>{{form.order_sn}}</span>
              </el-col>
          </el-row >
            <el-row  style='margin-bottom:15px;'>
              <el-col :span='2'>
                  手机号:
              </el-col>
              <el-col :span='10'>
                   <span>{{form.to_mobile}}</span>
              </el-col>
          </el-row>
            <el-row  style='margin-bottom:15px;'>
              <el-col :span='2'>
                  支付方式:
              </el-col>
              <el-col :span='10'>
                        <span v-if="form.pay_type == 0"> 未支付</span>
                                    <span v-if="form.pay_type == 1">线下支付</span>
                                    <span v-if="form.pay_type == 2">微信支付</span>
              </el-col>
          </el-row>
            <el-row  style='margin-bottom:15px;'>
              <el-col :span='2'>
                  是否赠品:
              </el-col>
              <el-col :span='10'>
                   <span v-if="form.isgift == 1">赠品</span>
                                    <span v-else>非赠品</span>
              </el-col>
          </el-row>
            <el-row  style='margin-bottom:15px;'>
              <el-col :span='2'>
                  订单留言:
              </el-col>
              <el-col :span='10'>
                  <span>{{form.order_notes}}</span>
              </el-col>
          </el-row>
            <el-row  style='margin-bottom:15px;'>
              <el-col :span='2'>
                  产品清单:
              </el-col>
              <el-col :span='20'>
                  <el-table
                                        ref="multipleTable"
                                        :data="form.product"
                                        v-loading="loading"
                                        border
                                        stripe
                                        style="width: 100%;margin: 20px">
                                    <el-table-column
                                            prop="product_sn"
                                            label="产品编号"
                                            fixed>
                                     
                                    </el-table-column>
                                    <el-table-column
                                            prop="product_name"
                                            label="产品名称"

                                            show-overflow-tooltip>
                                
                                    </el-table-column>
                                        <el-table-column
                                            prop="product_specs"
                                            label="产品规格"

                                            show-overflow-tooltip>
                                
                                    </el-table-column>
                                        <el-table-column
                                            prop="attribute_name"
                                            label="商品属性"

                                            show-overflow-tooltip>
                                
                                    </el-table-column>
                                        <el-table-column
                                            prop="last_price"
                                            label="订货价"

                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                {{parseFloat(scope.row.last_price/100)}}
                                            </template>
                                
                                    </el-table-column>
                                        <el-table-column
                                            prop="num"
                                            label="数量"
                                            fixed="right"
                                            show-overflow-tooltip>
                                
                                    </el-table-column>
                                </el-table>
              </el-col>
          </el-row>
                                
            <div class="btns">
                    <el-button  @click="back">返回列表</el-button>
            </div>
    </div>
</template>

<script>
export default {
    name:'myorderDetail',
    data(){
        return{
            form:{},
            loading:false,
            tableData2:[]
        }
    },
  methods:{
        init(){
        if(this.$route.query.order_id){
            this.$get('logistics_1','/orders/detail',{
                order_id:this.$route.query.order_id
            }).then(res=>{
                this.form=res.data
            })
        }
    },
    back(){
        this.$router.push({name:'myorder'})
    }
  }
  ,
  created(){
      this.init()
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-row{
    margin-bottom:15px;
}
.btns{
    text-align: center;
}
</style>


